<template>
  <div class="ihu-nav-bar">
    <ul>
      <li
        v-for="(field, index) in navItems"
        :key="field.id+index"
        :class="currentlySelectedNavItem.id === field.id ? navType + '-nav-item-selected' : navType + '-nav-item-unselected'"
        @click="navClickAction(field)">
        {{ field.value }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'ihu-nav-bar',
    props: {
      navItems: {
        type: Array,
        required: true,
      },
      disabledItems: {
        type: Array,
        default: () => [],
      },
      navType: {
        type: String,
        required: false,
        default: 'primary',
      },
      currentlySelectedNavItem: {
        type: Object,
        required: true,
        default: () => ({}),
      },
    },
    data() {
      return {
      };
    },
    methods: {
      navClickAction(field) {
        const disabledIndex = this.disabledItems.findIndex(da => da.id === field.id);
        if (disabledIndex > -1) {
          this.$emit('itemDisabled', field);
        } else {
          this.$emit('navBarItemClicked', field);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .ihu-nav-bar {
    ul {
      list-style-type: none;
      margin-bottom: 11px;
      li {
        display: inline;
        font-style: normal;
        flex-direction: column;
        align-items: center;
        padding-bottom: 11px;
        cursor: pointer;
        &.primary-nav-item-selected {
          margin: 11px 21px;
          line-height: 125%;
          font-weight: 500;
          font-size: 16.8px;
          @include themify {
            color: getColor('ihuNavBarPrimaryListItemSelectedColor', 'ihu');
            border-bottom: 3px solid;
            border-color: getColor('ihuNavBarPrimaryListItemSelectedBorderColor', 'ihu');
          }
        }
        &.primary-nav-item-unselected {
          margin: 11px 21px;
          line-height: 125%;
          font-weight: 500;
          font-size: 16.8px;
          @include themify {
            color: getColor('ihuNavBarPrimaryListItemUnselectedColor', 'ihu');
          }
        }
        &.secondary-nav-item-selected {
          margin: 11px 24px 11px 0px;
          font-weight: 500;
          font-size: 14px;
          line-height: 120%;
          @include themify {
            color: getColor('ihuNavBarSecondaryListItemSelectedColor', 'ihu');
            border-bottom: 2px solid;
            border-color: getColor('ihuNavBarSecondaryListItemSelectedBorderColor', 'ihu');
          }
        }
        &.secondary-nav-item-unselected {
          margin: 11px 24px 11px 0px;
          font-weight: 500;
          font-size: 14px;
          line-height: 120%;
          @include themify {
            color: getColor('ihuNavBarSecondaryListItemUnselectedColor', 'ihu');
          }
        }
      }
    }
  }
</style>
